import { useState, useEffect, useRef } from 'react';
import { getUserStatus, logout } from 'api/index';
import { decode } from 'html-entities';
import { FULFILLED, FAILURE, NOT_LOGGED_IN, E_CHOOSE_PLAN, E_ACCOUNT_CREATED, E_TRIAL_CREATED, E_SUBSCRIPTION_CREATED } from './constants';
import Asterisk from '@/components/elements/Asterisk/Asterisk';
import * as Sentry from '@sentry/nextjs';

export const countries = [
    {"name": "Albania", "code": "AL"},
    {"name": "Åland Islands", "code": "AX"},
    {"name": "American Samoa", "code": "AS"},
    {"name": "Andorra", "code": "AD"},
    {"name": "Anguilla", "code": "AI"},
    {"name": "Antarctica", "code": "AQ"},
    {"name": "Antigua and Barbuda", "code": "AG"},
    {"name": "Argentina", "code": "AR"},
    {"name": "Armenia", "code": "AM"},
    {"name": "Aruba", "code": "AW"},
    {"name": "Australia", "code": "AU"},
    {"name": "Austria", "code": "AT"},
    {"name": "Azerbaijan", "code": "AZ"},
    {"name": "Bahamas", "code": "BS"},
    {"name": "Bahrain", "code": "BH"},
    {"name": "Bangladesh", "code": "BD"},
    {"name": "Barbados", "code": "BB"},
    {"name": "Belgium", "code": "BE"},
    {"name": "Belize", "code": "BZ"},
    {"name": "Bermuda", "code": "BM"},
    {"name": "Bhutan", "code": "BT"},
    {"name": "Bolivia (Plurinational State of)", "code": "BO"},
    {"name": "Bonaire, Sint Eustatius and Saba", "code": "BQ"},
    {"name": "Bosnia and Herzegovina", "code": "BA"},
    {"name": "Bouvet Island", "code": "BV"},
    {"name": "Brazil", "code": "BR"},
    {"name": "British Indian Ocean Territory", "code": "IO"},
    {"name": "Brunei Darussalam", "code": "BN"},
    {"name": "Bulgaria", "code": "BG"},
    {"name": "Cambodia", "code": "KH"},
    {"name": "Canada", "code": "CA"},
    {"name": "Cayman Islands", "code": "KY"},
    {"name": "Chile", "code": "CL"},
    {"name": "China", "code": "CN"},
    {"name": "Christmas Island", "code": "CX"},
    {"name": "Cocos (Keeling) Islands", "code": "CC"},
    {"name": "Colombia", "code": "CO"},
    {"name": "Cook Islands", "code": "CK"},
    {"name": "Costa Rica", "code": "CR"},
    {"name": "Croatia", "code": "HR"},
    {"name": "Curaçao", "code": "CW"},
    {"name": "Cyprus", "code": "CY"},
    {"name": "Czechia", "code": "CZ"},
    {"name": "Denmark", "code": "DK"},
    {"name": "Dominica", "code": "DM"},
    {"name": "Dominican Republic", "code": "DO"},
    {"name": "Ecuador", "code": "EC"},
    {"name": "El Salvador", "code": "SV"},
    {"name": "Estonia", "code": "EE"},
    {"name": "Falkland Islands [Malvinas]", "code": "FK"},
    {"name": "Faroe Islands", "code": "FO"},
    {"name": "Fiji", "code": "FJ"},
    {"name": "Finland", "code": "FI"},
    {"name": "France", "code": "FR"},
    {"name": "French Guiana", "code": "GF"},
    {"name": "French Polynesia", "code": "PF"},
    {"name": "French Southern Territories", "code": "TF"},
    {"name": "Georgia", "code": "GE"},
    {"name": "Germany", "code": "DE"},
    {"name": "Gibraltar", "code": "GI"},
    {"name": "Greece", "code": "GR"},
    {"name": "Greenland", "code": "GL"},
    {"name": "Grenada", "code": "GD"},
    {"name": "Guadeloupe", "code": "GP"},
    {"name": "Guam", "code": "GU"},
    {"name": "Guatemala", "code": "GT"},
    {"name": "Guernsey", "code": "GG"},
    {"name": "Guinea", "code": "GN"},
    {"name": "Guinea-Bissau", "code": "GW"},
    {"name": "Guyana", "code": "GY"},
    {"name": "Haiti", "code": "HT"},
    {"name": "Heard Island and McDonald Islands", "code": "HM"},
    {"name": "Holy See", "code": "VA"},
    {"name": "Honduras", "code": "HN"},
    {"name": "Hong Kong", "code": "HK"},
    {"name": "Hungary", "code": "HU"},
    {"name": "Iceland", "code": "IS"},
    {"name": "India", "code": "IN"},
    {"name": "Ireland", "code": "IE"},
    {"name": "Isle of Man", "code": "IM"},
    {"name": "Israel", "code": "IL"},
    {"name": "Italy", "code": "IT"},
    {"name": "Jamaica", "code": "JM"},
    {"name": "Japan", "code": "JP"},
    {"name": "Jersey", "code": "JE"},
    {"name": "Jordan", "code": "JO"},
    {"name": "Kazakhstan", "code": "KZ"},
    {"name": "Kiribati", "code": "KI"},
    {"name": "Korea (the Democratic People's Republic of)", "code": "KP"},
    {"name": "Kuwait", "code": "KW"},
    {"name": "Kyrgyzstan", "code": "KG"},
    {"name": "Lao People's Democratic Republic", "code": "LA"},
    {"name": "Latvia", "code": "LV"},
    {"name": "Liechtenstein", "code": "LI"},
    {"name": "Lithuania", "code": "LT"},
    {"name": "Luxembourg", "code": "LU"},
    {"name": "Macao", "code": "MO"},
    {"name": "Malaysia", "code": "MY"},
    {"name": "Maldives", "code": "MV"},
    {"name": "Malta", "code": "MT"},
    {"name": "Marshall Islands", "code": "MH"},
    {"name": "Martinique", "code": "MQ"},
    {"name": "Mexico", "code": "MX"},
    {"name": "Micronesia (Federated States of)", "code": "FM"},
    {"name": "Moldova (the Republic of)", "code": "MD"},
    {"name": "Monaco", "code": "MC"},
    {"name": "Mongolia", "code": "MN"},
    {"name": "Montenegro", "code": "ME"},
    {"name": "Montserrat", "code": "MS"},
    {"name": "Myanmar", "code": "MM"},
    {"name": "Nauru", "code": "NR"},
    {"name": "Nepal", "code": "NP"},
    {"name": "Netherlands", "code": "NL"},
    {"name": "New Caledonia", "code": "NC"},
    {"name": "New Zealand", "code": "NZ"},
    {"name": "Nicaragua", "code": "NI"},
    {"name": "Niue", "code": "NU"},
    {"name": "Norfolk Island", "code": "NF"},
    {"name": "Northern Mariana Islands", "code": "MP"},
    {"name": "Norway", "code": "NO"},
    {"name": "Oman", "code": "OM"},
    {"name": "Pakistan", "code": "PK"},
    {"name": "Palau", "code": "PW"},
    {"name": "Palestine, State of", "code": "PS"},
    {"name": "Panama", "code": "PA"},
    {"name": "Paraguay", "code": "PY"},
    {"name": "Peru", "code": "PE"},
    {"name": "Philippines", "code": "PH"},
    {"name": "Pitcairn", "code": "PN"},
    {"name": "Poland", "code": "PL"},
    {"name": "Portugal", "code": "PT"},
    {"name": "Puerto Rico", "code": "PR"},
    {"name": "Qatar", "code": "QA"},
    {"name": "Republic of North Macedonia", "code": "MK"},
    {"name": "Romania", "code": "RO"},
    {"name": "Russian Federation", "code": "RU"},
    {"name": "Saint Barthélemy", "code": "BL"},
    {"name": "Saint Kitts and Nevis", "code": "KN"},
    {"name": "Saint Lucia", "code": "LC"},
    {"name": "Saint Martin (French part)", "code": "MF"},
    {"name": "Saint Pierre and Miquelon", "code": "PM"},
    {"name": "Saint Vincent and the Grenadines", "code": "VC"},
    {"name": "Samoa", "code": "WS"},
    {"name": "San Marino", "code": "SM"},
    {"name": "Saudi Arabia", "code": "SA"},
    {"name": "Serbia", "code": "RS"},
    {"name": "Singapore", "code": "SG"},
    {"name": "Sint Maarten (Dutch part)", "code": "SX"},
    {"name": "Slovakia", "code": "SK"},
    {"name": "Slovenia", "code": "SI"},
    {"name": "Solomon Islands", "code": "SB"},
    {"name": "South Georgia and the South Sandwich Islands", "code": "GS"},
    {"name": "Spain", "code": "ES"},
    {"name": "Sri Lanka", "code": "LK"},
    {"name": "Suriname", "code": "SR"},
    {"name": "Svalbard and Jan Mayen", "code": "SJ"},
    {"name": "Sweden", "code": "SE"},
    {"name": "Switzerland", "code": "CH"},
    {"name": "Taiwan (Province of China)", "code": "TW"},
    {"name": "Tajikistan", "code": "TJ"},
    {"name": "Thailand", "code": "TH"},
    {"name": "Timor-Leste", "code": "TL"},
    {"name": "Tokelau", "code": "TK"},
    {"name": "Tonga", "code": "TO"},
    {"name": "Trinidad and Tobago", "code": "TT"},
    {"name": "Turkey", "code": "TR"},
    {"name": "Turkmenistan", "code": "TM"},
    {"name": "Turks and Caicos Islands", "code": "TC"},
    {"name": "Tuvalu", "code": "TV"},
    {"name": "Ukraine", "code": "UA"},
    {"name": "United Arab Emirates", "code": "AE"},
    {"name": "United Kingdom of Great Britain and Northern Ireland", "code": "GB"},
    {"name": "United States Minor Outlying Islands", "code": "UM"},
    {"name": "United States of America", "code": "US"},
    {"name": "Uruguay", "code": "UY"},
    {"name": "Uzbekistan", "code": "UZ"},
    {"name": "Vanuatu", "code": "VU"},
    {"name": "Viet Nam", "code": "VN"},
    {"name": "Virgin Islands (British)", "code": "VG"},
    {"name": "Virgin Islands (U.S.)", "code": "VI"},
    {"name": "Wallis and Futuna", "code": "WF"},
    {"name": "Yemen", "code": "YE"},
  ]

export const acceptedCardTypes = ["visa", "mastercard", "discover"];

export const getCardType = (number) => {
    try{

        if(number === undefined) return ""
        const stringNum = number?.toString()
        // visa
        var re = new RegExp("^4");
        if (stringNum.match(re) != null)
        return "visa";

        // Mastercard
        re = new RegExp("^5[1-5]");
        if (stringNum.match(re) != null)
        return "mastercard";

        // AMEX
        re = new RegExp("^3[47]");
        if (stringNum.match(re) != null)
        return "amex";

        // Discover
        re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
        if (stringNum.match(re) != null)
        return "discover";

        // Diners
        re = new RegExp("^36");
        if (stringNum.match(re) != null)
        return "diners";

        // Diners - Carte Blanche
        re = new RegExp("^30[0-5]");
        if (stringNum.match(re) != null)
        return "diners - carte blanche";

        // JCB
        re = new RegExp("^35(2[89]|[3-8][0-9])");
        if (stringNum.match(re) != null)
        return "jcb";

        // Visa Electron
        re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
        if (stringNum.match(re) != null)
        return "visa electron";
    }catch(e){
        console.log('Error: ', e.message)
    }
    return ""
}

// It is counter-advised to have such specific attempts to validate whole card numbers because of the ever changing patterns in big card issuers. But just in case we ever decide to fall back on more severe validation, these regEx will do.
export const cardNumberCompliesWithType = (cardNumber, cardType) => {

    const cardTypeValidators = {
        visa: () => {
            var re = new RegExp("^4[0-9]{12}(?:[0-9]{3})?$");
            return re.test(cardNumber)
        },
        mastercard: () => {
            var re = new RegExp("^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$");
            return re.test(cardNumber)
        },
        discover: () => {
            var re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
            return re.test(cardNumber)
        }
    }

    if(acceptedCardTypes.includes(cardType)){
        return cardTypeValidators[cardType]()
    }

    return false

}

export const validate = {

    plan: (plan, price) => {
        const MIN_PRICE = 2.99
        const valid = (plan !== null || price >= MIN_PRICE)
        let message = "Select a plan";
        if(plan === null && price !==""){
            message = `Price cannot be lower than $${MIN_PRICE}`;
        }
        return {valid, message}
    },
    email: (email) => {
        const regEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const valid = regEx.test(String(email).toLowerCase());
        return {valid, message: "Enter a valid email address."};
    },
    password: (password) => {
        const regEx = /\d/;
        const valid = (regEx.test(String(password).toLowerCase()) && password.length > 8 && password.length < 100);
        return {valid, message: "Password length must be greater than 8 characters and contain at least 1 number."};
    },
    newPassword: (newPassword, newPassword2) => {
        const valid = (newPassword === newPassword2)
        return {valid, message: "Passwords do not match."}
    },
    cardNumber: (cardNumber, cardType) => {
        const valid = (cardNumber?.length >= 12 && acceptedCardTypes.includes(cardType))
         return {valid, message: "Please enter a valid card number."}
    },
    expiryDate: (month, year) => {
        const regEx = /\b(0[1-9]|1[0-2])\/?([0-9]{4}|[0-9]{2})\b/;
        const valid = regEx.test(month+year)
        return {valid, message: "Please enter a valid expiration date (MM/YY)."}
    },
    expiryMonth: (month) => {
        const valid = (month <= 12 && month >= 1)
        return {valid, message: "Please select a valid month."}
    },
    expiryYear: (year) => {
        const fullYear = parseInt(year) + 2000
        const valid = (fullYear >= new Date().getFullYear() && fullYear <= new Date().getFullYear() + 10)
        return {valid, message: "Please select a valid year."}
    },
    cvv: (cvv, cardType) => {
        let cvvLength = 3
        if(cardType === "amex"){
            cvvLength = 4
        }
        const valid = cvv?.length === cvvLength
        return {valid, message: `CVV should contain ${cvvLength} digits.`}
    },
    notEmpty: (field, value) => {
        const valid = value?.length > 0
        return {valid, message: `${field} can not have empty value.`}
    }




}

export const isInViewport = (element) => {
  const rect = element.getBoundingClientRect();
  return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

export const timeSleep = async (sleep=1500) => {
    await new Promise(resolve => setTimeout(resolve, sleep));
}

// Created to simulate async calls to API
export const fakeRequest = async (status="success", message="", timeout=1500) => {
    await new Promise(resolve => setTimeout(resolve, timeout));
    return {data:{status, message}}
}

export const runValidation = (toValidate) => {
    for(let validation of toValidate){
        if(!validation.valid){
            return {valid: false, message: validation.message}
        }
    }
    return {valid: true}
}

export const shirtAsterisk = (setShowShirt) => {
    return <Asterisk position={{top: 0, right: 0}} translate={{x: "40%"}} scale={.7} interaction={{animate:true, action: ()=>{setShowShirt(true)}}}>
        FREE<br />T-SHIRT
    </Asterisk>
}

/* Custom hook to check if element is in viewport */
export function useOnScreen(ref) {

    const [isIntersecting, setIntersecting] = useState(false)

    let observer;

    useEffect(()=>{
        try{
            observer = new IntersectionObserver(
                ([entry]) => setIntersecting(entry.isIntersecting)
                )
        }catch(e){
            console.log('Intersection observer is not available. Browser does not support it.')
            // We return "not available" so that truth checkers for "isInterseting" pass the check and elements are not kept hidden from the DOM. Also could be used to handle a specific scenario for a not available Observer.
            setIntersecting("not available")
        }
    }, [])

    useEffect(() => {
        try{
            observer.observe(ref.current)
        }catch(e){
            console.log('Intersection observer failed: ', e)
        }
        return () => { observer.disconnect() }
    }, [])

    return isIntersecting
}

export const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });
    useEffect(() => {
      function handleResize() {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
      window.addEventListener("resize", handleResize);
      handleResize();
      return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
}

export const useScrollPosition = () => {
    const[scrollPosition, setScrollPosition] = useState(0)
    function updateScroll(){
        const position = window.pageYOffset;
        setScrollPosition(position);
    }

    useEffect(()=>{
        window.addEventListener('scroll', updateScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', updateScroll);
        };
    }, [])

    return scrollPosition;
}

export const useScrolling = (delay=150) => {

    const [scrolling, setScrolling] = useState(false)
    const lastScrolled = useRef(Date.now())

    useEffect(()=>{
        window.addEventListener('scroll', updateScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', updateScroll);
        };
    }, [])

    function updateScroll(){
        setScrolling(true)
        lastScrolled.current = Date.now()
        setTimeout(() => {
            (Date.now() - lastScrolled.current) >= delay && setScrolling(false)
        }, delay);
    }


    return scrolling;

}

export const useFirstRender = () => {
    const isFirstRender = useRef(true);
    useEffect(() => {
      isFirstRender.current = false;
    }, []);
    return isFirstRender.current;
  };

export const svgFilterColors = {
    rose: "invert(56%) sepia(69%) saturate(439%) hue-rotate(308deg) brightness(116%) contrast(98%)",
    white: "invert(100%) sepia(100%) saturate(1%) hue-rotate(258deg) brightness(101%) contrast(101%)",
    beige: "invert(94%) sepia(6%) saturate(1473%) hue-rotate(318deg) brightness(107%) contrast(104%)",
    charcoal: "invert(12%) sepia(21%) saturate(179%) hue-rotate(7deg) brightness(98%) contrast(92%)",
}

export const colors = {
    beige: "#fff7e1",
    blue: "#88B5F4",
    blueDark: "#5793E9",
    rose: "#fd949e",
    roseDark: "#d9757f",
    charcoal: "#272623",
    charcoalDark: "#181714",
    glow: "#F6BC41",
    success: "#75C89C",
    error: "#EB6969",
    errorDark: "#c24848",
    white: "#ffffff",
    ooeyGooeyWhite: "#FFFFF3",
}

export const breakPoints = {
    mobile: 800,
}

export const socialLinks = {
    twitter: 'https://twitter.com/xoafterglow',
    instagram: 'http://instagram.com/xoaftergloww',
    facebook: 'https://www.facebook.com/xoafterglow',
    tiktok: 'https://www.tiktok.com/@xo_afterglow'
}

export const pressLinks = {
    Forbes: 'https://www.forbes.com/sites/marijabutkovic/2021/06/10/next-generation-of-sextech-entrepreneurs-is-here-disrupting-the-37-billion-sexual-wellness-market/?sh=72e0211273d2',
    Newsweek: 'https://www.newsweek.com/i-started-female-led-porn-site-1566784',
    MarieClaire: 'https://www.marieclaire.co.uk/life/sex-and-relationships/ethical-porn-474913',
    NewYorkTimes: 'https://www.nytimes.com/2021/02/19/style/caitlin-stasey-bridge-and-tunnel-afterglow.html',
    Buzzfeed: 'https://www.buzzfeed.com/claratsacwang/sex-tech-founders-are-changing-the-world-of-sex',
}

export const tryLocalStorage = {

    ERROR_MESSAGE: 'Error occured. Possibly localStorage is either blocked or not supported.',
    get: (key) => {
        try{
            return JSON.parse(localStorage.getItem(key))
        }catch(e){
            console.log(tryLocalStorage.ERROR_MESSAGE, e)
            return false
        }
    },
    set: (key, value) => {
        try{
            return localStorage.setItem(key, JSON.stringify(value))
        }catch(e){
            console.log(tryLocalStorage.ERROR_MESSAGE, e)
            return false
        }
    }

}

export const svgLogo = (size=130) => <svg width={size} height={Math.floor(size*0.2)} viewBox="0 0 284 57" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M30.4872 43.7975H21.2722V42.2608C19.2259 43.5742 16.7224 44.3622 13.7068 44.3622C6.25707 44.3622 0 38.1629 0 29.9724C0 21.7241 6.25707 15.5825 13.7068 15.5825C16.7224 15.5825 19.2233 16.3705 21.2722 17.684V16.205H30.4872V43.7975ZM21.2722 34.241V25.709C19.5674 23.7178 17.5762 23.0821 15.5273 23.0821C11.7735 23.0821 9.04416 26.1529 9.04416 29.9645C9.04416 33.776 11.7735 36.7943 15.5273 36.7943C17.5762 36.7943 19.5674 36.2321 21.2722 34.241ZM61.2003 16.2103V24.1171H51.481V43.7975H42.2685V24.1171H35.4991V16.2103H42.2685V12.911C42.2685 4.94899 47.3305 0 54.3836 0C56.8636 0.0145198 59.3308 0.358139 61.7204 1.02185L60.47 8.70275C59.0891 8.39513 57.6814 8.22356 56.267 8.19051C53.3775 8.19051 51.4888 9.95314 51.4888 12.6824V16.2103H61.2003ZM89.4783 43.2852C85.8953 44.4227 83.8463 44.6486 81.1171 44.6486C74.4606 44.6486 70.0239 39.7574 70.0239 32.3024V24.1171H64.6205V16.2103H70.0239V6.82456H79.2336V16.2103H88.6193V24.1171H79.2336V32.0213C79.2336 34.8084 80.8255 36.1744 83.5574 36.1744C84.8708 36.1744 86.3997 35.8906 88.4486 35.4914L89.4783 43.2852ZM122.24 32.5335L122.298 32.7043H102.613C103.351 35.2077 105.287 37.141 108.812 37.141C110.745 37.141 112.227 36.4029 113.015 35.1499H122.117C120.804 40.8396 115.518 44.4226 108.694 44.4226C99.6495 44.4226 93.6209 38.3809 93.6209 29.975C93.6209 21.6137 99.4787 15.5851 108.294 15.5851C116.314 15.5851 122.401 21.1015 122.401 29.405C122.431 30.4506 122.375 31.4969 122.235 32.5335H122.24ZM102.505 27.3008H113.766C113.254 24.2878 111.263 22.6934 108.305 22.6934C105.171 22.6934 103.18 24.5138 102.5 27.3008H102.505ZM147.385 24.5138C142.89 24.6845 140.045 25.8797 137.883 28.0416V43.8027H128.671V16.2208H137.883V19.1681C140.332 17.0666 143.289 15.7532 147.385 15.7532V24.5138ZM182.251 43.3404C182.251 51.988 176.107 57 167.462 57C159.1 57 153.014 52.2218 152.56 45.0557H161.662C162.116 47.6143 164.049 49.2088 167.462 49.2088C170.59 49.2088 173.036 47.2728 173.036 43.519V40.8922C170.755 42.2048 168.16 42.8731 165.528 42.8255C158.076 42.8255 151.821 36.8547 151.821 29.4023C151.821 20.9964 158.076 15.241 165.528 15.241C168.174 15.2022 170.776 15.9115 173.036 17.2873V16.2077H182.251V43.3404ZM173.036 32.9328V25.3149C172.339 24.4906 171.467 23.8329 170.483 23.3901C169.498 22.9473 168.428 22.7308 167.349 22.7564C163.595 22.7564 160.863 25.4305 160.863 29.4102C160.863 32.4258 163.595 35.4966 167.349 35.4966C168.427 35.5208 169.497 35.303 170.48 34.8594C171.464 34.4157 172.335 33.7574 173.03 32.9328H173.036ZM199.485 43.7975H190.271V3.41228H199.485V43.7975ZM273.773 42.4H265.354L260.975 28.1808L256.546 42.4H248.185L238.686 14.8181H248.355L252.677 29.6046L257.334 14.8154H264.613L269.278 29.489L273.602 14.8154H283.214L273.773 42.4Z" fill="#FFFFFF"/>
        <path d="M236.685 24.6424C236.467 19.457 234 15.1148 230.262 12.5247C231.978 15.0265 232.943 17.9668 233.044 20.9989C233.412 29.7332 227.528 36.2189 218.875 36.6156C215.263 36.7837 212.045 35.8722 209.471 34.1306C212.216 38.168 216.894 40.5164 222.516 40.259C231.171 39.8597 237.053 33.3793 236.685 24.6424Z" fill="#5694EF"/>
        <path d="M221.066 9.97151C224.329 9.77498 227.565 10.6736 230.259 12.5248C227.449 8.48996 222.776 6.05224 217.422 6.32806C209.016 6.76149 202.856 13.5992 203.2 22.1364C203.41 27.3901 205.761 31.6194 209.468 34.1306C207.908 31.8348 206.97 28.9951 206.841 25.7773C206.502 17.2426 212.654 10.4049 221.066 9.97151Z" fill="#FFC100"/>
        <path d="M218.874 36.6156C227.527 36.219 233.411 29.7333 233.043 20.999C232.943 17.9668 231.977 15.0266 230.261 12.5248C227.567 10.6736 224.331 9.77497 221.067 9.9715C212.661 10.4049 206.504 17.2426 206.846 25.7772C206.974 28.9951 207.912 31.8348 209.472 34.1306C212.039 35.8722 215.262 36.7943 218.874 36.6156Z" fill="#FD949E"/>
    </svg>

export const svgLogoNew = (size=130) => {
    return <img src="next/new_ag_logo_no_orb.png" width={size}/>
}

export const hamburgerMenuNewLogo = (size=130) => {
    return <img src="next/new_ag_logo_no_orb.png" width={size}/>
}

export const playButton = (size=52) => <svg width={size} height={size} viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.9001 36.075L34.9642 27.0334C35.6617 26.5167 35.6617 25.4834 34.9642 24.9667L22.9001 15.925C22.0476 15.2792 20.8334 15.8992 20.8334 16.9584V35.0417C20.8334 36.1009 22.0476 36.7209 22.9001 36.075ZM26.0001 0.166687C11.7401 0.166687 0.166748 11.74 0.166748 26C0.166748 40.26 11.7401 51.8334 26.0001 51.8334C40.2601 51.8334 51.8334 40.26 51.8334 26C51.8334 11.74 40.2601 0.166687 26.0001 0.166687ZM26.0001 46.6667C14.6076 46.6667 5.33342 37.3925 5.33342 26C5.33342 14.6075 14.6076 5.33335 26.0001 5.33335C37.3926 5.33335 46.6667 14.6075 46.6667 26C46.6667 37.3925 37.3926 46.6667 26.0001 46.6667Z" fill="white" fillOpacity="0.7"/>
</svg>

export const handleLogout = (setAppLoading) => {
    setAppLoading(true)
    try{
        logout().then(()=>{
            window.location.href="/"
        })
    }catch(e){
        setAppLoading(false)
        Sentry.captureException(e)
    }
}
export const upArrow = (size=32) => <svg width={size} height={size*.6} viewBox="0 0 32 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M31.0167 17.7001C31.8333 16.8834 31.8333 15.5668 31.0167 14.7501L17.1666 0.900098C16.5167 0.250098 15.4667 0.250098 14.8167 0.900098L0.966648 14.7501C0.149981 15.5668 0.149981 16.8834 0.966648 17.7001C1.78331 18.5168 3.09998 18.5168 3.91665 17.7001L16 5.63343L28.0833 17.7168C28.8833 18.5168 30.2167 18.5168 31.0167 17.7001Z" fill="white"/>
</svg>

export const upArrowNew = (size=32, color="beige") => <svg width={size} height={size*.6} viewBox="0 0 32 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M31.0167 17.7001C31.8333 16.8834 31.8333 15.5668 31.0167 14.7501L17.1666 0.900098C16.5167 0.250098 15.4667 0.250098 14.8167 0.900098L0.966648 14.7501C0.149981 15.5668 0.149981 16.8834 0.966648 17.7001C1.78331 18.5168 3.09998 18.5168 3.91665 17.7001L16 5.63343L28.0833 17.7168C28.8833 18.5168 30.2167 18.5168 31.0167 17.7001Z" fill="white"/>
</svg>

export function getYmdDate(){
    return new Date().toISOString().split('T')[0]
}

export const track = (eventName, data, includeAnonId=false) => {
    console.log('track', eventName)
    if(process.env.NODE_ENV !== "development"){
        try{
            if(includeAnonId){
                data.anon_id = window?.analytics?.user()?.anonymousId()
            }
            window?.analytics?.track(eventName, data)
        }catch(e){
            console.log('Can not track events.')
        }
    }
}

function getPlanName(selectedPlan){
    return selectedPlan ? selectedPlan.name : "custom"
}

export function getPlanBillingAmount(signUpInfo){
    return parseFloat(signUpInfo.plan ? signUpInfo.plan.salePrice ? signUpInfo.plan.salePrice : signUpInfo.plan.price : signUpInfo.customPrice)
}

export function trackChoosePlan(signUpInfo, source=""){
    track(E_CHOOSE_PLAN, {
        plan_name: getPlanName(signUpInfo.plan),
        plan_billing_amount: getPlanBillingAmount(signUpInfo),
        plan_state: "active",
        code: signUpInfo?.accessCode?.valid ? signUpInfo.accessCode.code : null,
        type: signUpInfo?.type ? signUpInfo.type : null,
        source
    }, true)
}

export function trackAccountCreated(signUpInfo, source=""){
    track(E_ACCOUNT_CREATED, {
        plan_name: signUpInfo.plan ? signUpInfo.plan.name : null,
        plan_billing_amount: getPlanBillingAmount(signUpInfo),
        type: signUpInfo?.type ? signUpInfo.type : null,
        source
    }, true)
}

export function trackTrialCreated(signUpInfo, source=""){
    track(E_TRIAL_CREATED, {
        plan_name: getPlanName(signUpInfo.plan),
        plan_billing_amount: getPlanBillingAmount(signUpInfo),
        code: signUpInfo?.accessCode?.valid ? signUpInfo.accessCode.code : null,
        num_months: signUpInfo?.accessCode?.valid ? signUpInfo.accessCode.num_months : null,
        type: signUpInfo?.type ? signUpInfo.type : null,
        source
    }, true)
}

export function trackSubscriptionCreated(signUpInfo, source=""){
    track(E_SUBSCRIPTION_CREATED, {
        plan_name: getPlanName(signUpInfo.plan),
        plan_billing_amount: getPlanBillingAmount(signUpInfo),
        plan_state: "active",
        plan_start_date: getYmdDate(),
        type: signUpInfo?.type ? signUpInfo.type : null,
        source
    }, true)
}

export const scrollTo = (ref, yOffset=0, side="top") => {
    try{
        const element = ref.current;
        const y = element.getBoundingClientRect()[side] + window.pageYOffset + yOffset - (side === "bottom" ? window.innerHeight : 0);
        window.scrollTo({top: y, behavior: 'smooth'});
    }catch(e){
        console.log('An error occured inside scrollTo function. Probably the window object can not be accessed: ', e.message)
    }
}

export const actionMenu = () => {
    return <svg width="4" height="16" viewBox="0 0 4 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4ZM2 6C0.9 6 0 6.9 0 8C0 9.1 0.9 10 2 10C3.1 10 4 9.1 4 8C4 6.9 3.1 6 2 6ZM2 12C0.9 12 0 12.9 0 14C0 15.1 0.9 16 2 16C3.1 16 4 15.1 4 14C4 12.9 3.1 12 2 12Z" fill="white"/>
            </svg>
}

export const CLOUD_CONTENT_URL = "https://h6d2u7w3.ssl.hwcdn.net";

export async function tryGetUserStatus(context){
    try{
        return context.req.cookies['XSRF-TOKEN'] === undefined ? false : await getUserStatus(context)
    }catch(e){
        Sentry.captureException(e)
        return { status: e?.response?.status }
    }
}

export function getMinutesWSeconds(seconds){
    let minutes = Math.floor(seconds / 60);
    let remainingSeconds = seconds - minutes * 60;
    if(remainingSeconds < 10){
        remainingSeconds = "0" + remainingSeconds
    }
    return minutes + ":" + remainingSeconds
}

export function backBtn(size=12){
    return <svg width={size} height={size * 1.75} viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.60938 20.3906C9.86719 20.6484 10.1953 20.7891 10.582 20.7891C11.3555 20.7891 11.9766 20.1797 11.9766 19.4062C11.9766 19.0195 11.8125 18.668 11.543 18.3984L3.33984 10.3828L11.543 2.39062C11.8125 2.12109 11.9766 1.75781 11.9766 1.38281C11.9766 0.609375 11.3555 0 10.582 0C10.1953 0 9.86719 0.140625 9.60938 0.398438L0.492188 9.30469C0.164062 9.60938 0.0117188 9.98438 0 10.3945C0 10.8047 0.164062 11.1562 0.492188 11.4727L9.60938 20.3906Z" fill="white"/>
    </svg>
}

export function sliceIfNecessary(string, limit){
    if(typeof string === "string"){
        if(string.length > limit){
            return string.slice(0, limit) + "..."
        }else{
            return string
        }
    }
    return string
}

export function capitalize (string){
    if(typeof string === "string"){
        return string.charAt(0).toUpperCase() + string.slice(1, string.length)
    }
    return "";
}

export const loupe = () => {
    return <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M12.7231 7C12.7231 9.76142 10.4846 12 7.72314 12C4.96172 12 2.72314 9.76142 2.72314 7C2.72314 4.23858 4.96172 2 7.72314 2C10.4846 2 12.7231 4.23858 12.7231 7ZM12.1677 12.4082C10.9588 13.4028 9.41073 14 7.72314 14C3.85715 14 0.723145 10.866 0.723145 7C0.723145 3.13401 3.85715 0 7.72314 0C11.5891 0 14.7231 3.13401 14.7231 7C14.7231 8.45647 14.2783 9.80904 13.5171 10.9293L19.7045 17.1167C20.095 17.5072 20.095 18.1403 19.7045 18.5309C19.314 18.9214 18.6808 18.9214 18.2903 18.5309L12.1677 12.4082Z" fill="white"/>
    </svg>
}

export const cross = (size=10, color="beige") => {
    return <svg width={size} height={size} viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.66938 0.976875C9.37687 0.684375 8.90438 0.684375 8.61187 0.976875L4.94438 4.63688L1.27688 0.969375C0.984375 0.676875 0.511875 0.676875 0.219375 0.969375C-0.073125 1.26188 -0.073125 1.73438 0.219375 2.02688L3.88688 5.69438L0.219375 9.36187C-0.073125 9.65438 -0.073125 10.1269 0.219375 10.4194C0.511875 10.7119 0.984375 10.7119 1.27688 10.4194L4.94438 6.75188L8.61187 10.4194C8.90438 10.7119 9.37687 10.7119 9.66938 10.4194C9.96187 10.1269 9.96187 9.65438 9.66938 9.36187L6.00188 5.69438L9.66938 2.02688C9.95438 1.74188 9.95438 1.26188 9.66938 0.976875Z" fill={colors[color]} />
    </svg>
}

export const filtersIcon = (size=31) => {
    return <img src ="next/Search_White_L.png" width={size} height={size}/>
}

export const arrow = (color, direction="down") => {
    function getArrowRotation(direction){
        switch(direction){
            case "down":
                return "180deg";
            case "up":
                return "0deg";
            case "left":
                return "90deg";
            case "right":
                return "270deg";
        }
    }
    const rotateZ = getArrowRotation(direction)
    return <svg style={{transform: `rotateZ(${rotateZ})`}} width="10" height="5" viewBox="0 0 10 5" fill="charcoalDark" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0L5 5L10 0H0Z" fill={colors[color]} />
            </svg>
}

export const arrowVarSize = (color, direction, width, height) => {
    function getArrowRotation(direction){
        switch(direction){
            case "down":
                return "180deg";
            case "up":
                return "0deg";
            case "left":
                return "90deg";
            case "right":
                return "270deg";
        }
    }
    const rotateZ = getArrowRotation(direction)
    return <svg style={{transform: `rotateZ(${rotateZ})`}} width={width} height={height} viewBox="0 0 10 5" fill="ooeyGooeyWhite" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0L5 5L10 0H0Z" fill={colors[color]} />
            </svg>
}

export const arrow2 = (color, direction="down", size=9) => {
    const width = size
    const height = Math.round((width / 3)*4)
    function getArrowRotation(direction){
        switch(direction){
            case "down":
                return "270deg";
            case "up":
                return "90deg";
            case "left":
                return "0deg";
            case "right":
                return "180deg";
        }
    }
    const rotateZ = getArrowRotation(direction)
    return <svg style={{transform: `rotateZ(${rotateZ})`}} width={width} height={height} viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.16016 1.41L3.58016 6L8.16016 10.59L6.75016 12L0.750156 6L6.75016 0L8.16016 1.41Z" fill={colors[color]} />
            </svg>
}

export const arrow3 = (color, direction="down", size=24) => {
    const width = size
    const height = Math.round((width / 3)*4)
    function getArrowRotation(direction){
        switch(direction){
            case "down":
                return "270deg";
            case "up":
                return "90deg";
            case "left":
                return "0deg";
            case "right":
                return "180deg";
        }
    }
    const rotateZ = getArrowRotation(direction)
    return <svg style={{transform: `rotateZ(${rotateZ})`}} width={size} height={size} fill="none"><g filter="url(#a)"><circle cx="12" cy="12" r="12" fill="#FFFFF3" fill-opacity=".1"/><circle cx="12" cy="12" r="11" stroke="#FFFFF3" stroke-width="2"/></g><path fill="#FFFFF3" stroke="#FFFFF3" stroke-width=".5" d="M8.25 12a.606.606 0 0 0 .14.375l2.813 3.188a.57.57 0 0 0 .797.047.587.587 0 0 0 .047-.797l-1.986-2.25h5.877a.563.563 0 0 0 0-1.126h-5.877l1.986-2.25c.197-.22.169-.595-.047-.797-.225-.21-.6-.174-.797.047l-2.812 3.188A.525.525 0 0 0 8.25 12Z"/><defs><filter id="a" width="64" height="64" x="-20" y="-20" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feGaussianBlur in="BackgroundImageFix" stdDeviation="10"/><feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1394_337"/><feBlend in="SourceGraphic" in2="effect1_backgroundBlur_1394_337" result="shape"/></filter></defs></svg>
}

export const arrowDownRounded = (color, width, height) => {
    return <img src="next/down_arrow_icon.png" width={width} height={height}/>
}

export const afterglowLogoUpdatedMobileNav = (size=160) => {
    return <img src="next/plain_logo_for_new_mobile_nav.png" width={size}/>
}


export const isoLogo = (size=50) => {
    return <img src="img/afterglow_icon.png" className="afterglow-bullet-icon"/>
}

export const avatarEmptyIcon = (size=30) => {
    return <img src="next/nav_avatar_icon.png" className="nav_avatar_icon"/>
}

export function newIntercomConversation(email, body){
    return {
        "from": {
          "type": "user",
          email
        },
        body
      }
}

export const xoIntercom = {
    boot: (data={})=>{
        try{
            window.Intercom('boot', {
                app_id: 'xioo7330',
                ...data
            });
        }catch(e){
            console.log('Could not initiate intercom: ', e)
        }
    }
}

export class KlaviyoHelper{
    showPopUp(id){
        var _klOnsite = window._klOnsite || [];
        _klOnsite.push(['openForm', id]);
    }
}
export const videoResolutions = [
    {label: "480", key: "fourEighty"},
    {label: "720", key: "sevenTwenty"},
    {label: "1080", key: "tenEighty"},
]

export const squiggle = <svg width="64" height="5" viewBox="0 0 64 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M31.7336 1.25032C33.5704 1.25032 34.4702 2.11613 35.4233 3.03253C36.4295 3.99992 37.4699 5 39.5327 5C41.5955 5 42.6359 3.99949 43.6421 3.03208C44.5952 2.11615 45.4956 1.25032 47.3324 1.25032C49.1694 1.25032 50.0698 2.11613 51.0229 3.03253C52.0291 3.99992 53.0695 5 55.1326 5C57.1959 5 58.2364 3.99949 59.2428 3.03208C60.1959 2.11615 61.0963 1.25032 62.9334 1.25032C63.1544 1.25032 63.3335 0.970442 63.3335 0.625161C63.3335 0.27988 63.1546 0 62.9334 0C60.87 0 59.8296 1.00051 58.8232 1.96792C57.8703 2.88429 56.9699 3.75012 55.1326 3.75012C53.2958 3.75012 52.3954 2.88432 51.4423 1.96792C50.4361 1.00053 49.3957 0.000446171 47.3324 0.000446171C45.269 0.000446171 44.2288 1.00095 43.2227 1.96836C42.2693 2.8843 41.3695 3.75012 39.5327 3.75012C37.6959 3.75012 36.7961 2.88432 35.843 1.96792C34.8365 1.00053 33.7964 0.000446171 31.7336 0.000446171C31.5126 0.000446171 31.3335 0.280326 31.3335 0.625607C31.3335 0.970442 31.5123 1.25034 31.7336 1.25034V1.25032Z" fill="white"/>
    <path d="M0.400116 1.25032C2.2369 1.25032 3.13669 2.11613 4.08984 3.03253C5.09598 3.99992 6.13641 5 8.1992 5C10.262 5 11.3024 3.99949 12.3086 3.03208C13.2617 2.11615 14.1621 1.25032 15.9989 1.25032C17.8359 1.25032 18.7363 2.11613 19.6894 3.03253C20.6956 3.99992 21.736 5 23.7991 5C25.8624 5 26.9029 3.99949 27.9093 3.03208C28.8625 2.11615 29.7628 1.25032 31.5999 1.25032C31.8209 1.25032 32 0.970442 32 0.625161C32 0.27988 31.8211 0 31.5999 0C29.5365 0 28.4961 1.00051 27.4897 1.96792C26.5368 2.88429 25.6364 3.75012 23.7991 3.75012C21.9623 3.75012 21.0619 2.88432 20.1088 1.96792C19.1026 1.00053 18.0622 0.000446171 15.9989 0.000446171C13.9355 0.000446171 12.8954 1.00095 11.8892 1.96836C10.9358 2.8843 10.036 3.75012 8.1992 3.75012C6.36241 3.75012 5.46262 2.88432 4.50948 1.96792C3.50305 1.00053 2.4629 0.000446171 0.400116 0.000446171C0.179129 0.000446171 0 0.280326 0 0.625607C0 0.970442 0.178851 1.25034 0.400116 1.25034V1.25032Z" fill="white"/>
</svg>

export const blueCheckMark = (size=24) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.2608 13.8461C23.7352 13.3485 24 12.6876 24 12C24 11.3125 23.7352 10.6515 23.2608 10.1539L22.7337 9.60029C22.5076 9.36346 22.4177 9.02788 22.4954 8.70975L22.6744 7.96921C22.8374 7.30081 22.7362 6.59543 22.3922 5.99971C22.0483 5.40399 21.4877 4.96381 20.8276 4.77076L20.0966 4.55573C19.7815 4.46429 19.5351 4.21827 19.4435 3.9034L19.2292 3.17241C19.0368 2.51126 18.5962 1.94997 17.9997 1.60583C17.4032 1.26167 16.6969 1.16123 16.0281 1.32556L15.2876 1.50462C14.9692 1.58287 14.6329 1.49257 14.3963 1.26549L13.8434 0.739215C13.346 0.264778 12.6849 0 11.9975 0C11.31 0 10.6489 0.264764 10.1515 0.739215L9.59782 1.26627C9.3604 1.49125 9.02526 1.58097 8.70727 1.50464L7.97188 1.32558C7.30328 1.16259 6.59737 1.2636 6.00126 1.60756C5.40515 1.95153 4.96438 2.51207 4.77079 3.17243L4.55576 3.90342C4.46432 4.2185 4.2183 4.46491 3.90342 4.55654L3.17244 4.7708C2.51168 4.96383 1.95078 5.40443 1.60659 6.00069C1.26262 6.59719 1.16181 7.3031 1.32556 7.97189L1.50462 8.71243C1.5821 9.03076 1.49199 9.36687 1.26549 9.60371L0.739214 10.1566C0.264778 10.654 0 11.3151 0 12.0025C0 12.69 0.264763 13.3512 0.739214 13.8485L1.26627 14.4022C1.4924 14.639 1.58231 14.9747 1.50464 15.2927L1.32558 16.0333C1.16335 16.7013 1.26494 17.4061 1.60871 18.0012C1.95267 18.5964 2.51262 19.0362 3.17245 19.2292L3.90344 19.4442C4.21852 19.5357 4.46493 19.7817 4.55656 20.0966L4.77158 20.8285C4.96404 21.4895 5.40462 22.0504 6.00093 22.3944C6.59724 22.7385 7.30334 22.8388 7.97194 22.6744L8.71247 22.4954C9.03081 22.4181 9.36672 22.5082 9.60375 22.7345L10.1566 23.2608C10.6542 23.735 11.3152 23.9996 12.0025 23.9996C12.6901 23.9996 13.351 23.735 13.8486 23.2608L14.4022 22.7337C14.6389 22.5072 14.9748 22.4175 15.2928 22.4953L16.0333 22.6744C16.7014 22.8364 17.4059 22.7349 18.0011 22.3909C18.5963 22.0469 19.0361 21.4872 19.2293 20.8275L19.4443 20.0966C19.5357 19.7815 19.7818 19.5351 20.0966 19.4434L20.8285 19.2284C21.4891 19.0352 22.0495 18.5944 22.3932 17.9985C22.7372 17.4024 22.8378 16.6965 22.6744 16.0281L22.4954 15.2876C22.4179 14.9692 22.508 14.6331 22.7345 14.3963L23.2608 13.8461ZM17.571 9.63281L11.3498 15.5998C11.1901 15.753 10.9775 15.8386 10.7562 15.8386C10.535 15.8386 10.3223 15.753 10.1628 15.5998L6.42947 12.0217C6.20852 11.8097 6.11745 11.4958 6.19072 11.1985C6.2638 10.9012 6.49012 10.6655 6.78414 10.5802C7.07837 10.4948 7.39554 10.5729 7.61651 10.7849L10.7568 13.8L16.3834 8.40061C16.6067 8.2072 16.9137 8.14216 17.1963 8.22901C17.4786 8.31567 17.6965 8.5416 17.7727 8.82703C17.849 9.11246 17.7726 9.41683 17.571 9.63281Z" fill="#88B5F4"/>
</svg>

export function handleMissingCookies(context){
    return {
        redirect: {
            permanent: false,
            destination: '/login',
        },
    }
}

export const getRequestsStatus = (promiseResultsArray) =>{
    if(promiseResultsArray.length === 1) return statusOf(promiseResultsArray[0]);
    function statusOf(result){
        if(typeof result === "string") return result
        if(result.status !== FULFILLED) return FAILURE
        if(result.value.data?.message === NOT_LOGGED_IN) return result.value.data.message
        return FULFILLED
    }
    return promiseResultsArray.reduce((cur, next) => {
        if(typeof cur === "string" && cur !== FULFILLED) return cur
        if(statusOf(cur) === FULFILLED && statusOf(next) === FULFILLED) return FULFILLED
        if(statusOf(cur) !== FULFILLED) return statusOf(cur)
        return statusOf(next)
    })
}

export const protectedRoutes = [
    {route: '/journeys/[slug]', statusNeeded: 'active'},
    {route: '/video/[slug]', statusNeeded: 'active'},
    {route: '/watch', statusNeeded: 'active'},
    {route: '/account', statusNeeded: 'loggedIn'},
    {route: '/account/change-subscription', statusNeeded: 'loggedIn'},
    {route: '/account/cancel-subscription', statusNeeded: 'loggedIn'},
    {route: '/refer-a-friend', statusNeeded: 'loggedIn'}
];

export const canAccessRoute = (route, userStatus) => {
    const isProtected = protectedRoutes.find((pRoute) => pRoute.route === route)
    if(isProtected.statusNeeded === "active") return !!userStatus?.isActive
    return !!userStatus?.loggedIn
}

export function tabIsActive(path, tab){
    const articlesLinkValues = ['/ethical-porn', '/porn-for-couples', '/porn-for-women', '/read'];
    if(tab.label === 'Articles') return path.includes(tab.path) || articlesLinkValues.includes(path);
    if (tab?.path?.includes(path)){
        if (typeof window !== "undefined"){
            let activeTabUrl = window?.location?.href;
            return activeTabUrl?.includes(path);
        }
    }
}

export const checkMark = (size=18, color="white") => <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 9C18 4.03562 13.9641 0 9 0C4.03587 0 0 4.03587 0 9C0 13.9641 4.03587 18 9 18C13.9641 18 18 13.9641 18 9ZM14.4213 6.40176L8.00285 12.8202C7.83946 12.9836 7.61676 13.0688 7.40132 13.0688C7.17862 13.0688 6.9536 12.9836 6.79022 12.8202L3.57873 9.61101C3.24236 9.27465 3.24236 8.72518 3.57873 8.38895C3.91509 8.05259 4.45745 8.05259 4.79136 8.38895L7.39899 10.9872L13.2063 5.17991C13.5426 4.84354 14.085 4.84354 14.4189 5.17991C14.7576 5.52321 14.7576 6.06557 14.4212 6.4018L14.4213 6.40176Z" fill={colors[color]} fillOpacity="0.85"/>
</svg>

export const tick = (size=24) => <svg width={size} height={size/1.3} viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.893 0.557671L8.60701 13.4043L3.10748 7.6538C2.39637 6.91023 1.24428 6.91023 0.533331 7.6538C-0.177777 8.39736 -0.177777 9.60202 0.533331 10.3454L7.31975 17.4415C7.67385 17.8118 8.14181 18 8.60679 18C9.07181 18 9.53681 17.8149 9.89384 17.4415L23.4667 3.24929C24.1778 2.50573 24.1778 1.30106 23.4667 0.557671C22.7557 -0.18589 21.6041 -0.18589 20.893 0.557671Z" fill="white"/>
</svg>

export const hamburguerMenu = (size=24) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M0 6C0 5.44772 0.447715 5 1 5H23C23.5523 5 24 5.44772 24 6C24 6.55228 23.5523 7 23 7H1C0.447715 7 0 6.55228 0 6ZM0 13C0 12.4477 0.447715 12 1 12H23C23.5523 12 24 12.4477 24 13C24 13.5523 23.5523 14 23 14H1C0.447715 14 0 13.5523 0 13ZM1 19C0.447715 19 0 19.4477 0 20C0 20.5523 0.447715 21 1 21H23C23.5523 21 24 20.5523 24 20C24 19.4477 23.5523 19 23 19H1Z" fill="white"/>
</svg>

export const heart = (size=22, color="white") => <svg width={size} height={size / 1.15} viewBox="0 0 196 170" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M85.5381 14.8283C66.1133 -4.7988 34.4554 -4.96283 14.8283 14.4619C-4.7988 33.8867 -4.96283 65.5446 14.4619 85.1717L85.5381 14.8283ZM98 98.5L62.4619 133.672L98 169.58L133.538 133.672L98 98.5ZM181.538 85.1717C200.963 65.5446 200.799 33.8867 181.172 14.4619C161.545 -4.96283 129.887 -4.7988 110.462 14.8283L181.538 85.1717ZM14.4619 85.1717L62.4619 133.672L133.538 63.3283L85.5381 14.8283L14.4619 85.1717ZM133.538 133.672L181.538 85.1717L110.462 14.8283L62.4619 63.3283L133.538 133.672Z" fill={colors[color]} />
</svg>

export const thumbsUpThumbsDown = () => {
    return (
        <img src="/next/thumbs_up_thumbs_down.png"/>
    )
}

export const retrieveLeanTextFromHTML = (html) => {
    if(typeof html !== "string") return "";
    const leanText = decode(html.replace(/<\/?[^>]+(>|$)/g, ""))
    return leanText;
}

export const getMotionProps = (variant, isIntersecting=true, config={}) => {
    const variants = {
        slideUp: {
            initial: {opacity: 0, y: 30},
            animate: isIntersecting && {opacity: 1, y: 0},
            exit: {opacity: 0, y: 30},
            transition: {duration: .25, ease: "easeOut"}
        }
    }
    Object.keys(variants[variant]).map(function(key) {
        if(key === "initial" || key === "animate" || key === "exit" || key === "transition"){
            variants[variant][key] = {...variants[variant][key], ...config};
        }
    })
    const motionProps = variants[variant]
    return motionProps
}

export const useExperiment = (experimentId, testingVariant=false) => {
    const [variant, setVariant] = useState();
    const intervalCountRef = useRef(0);

    useEffect(() => {
      (async () => {
        if (window.dataLayer) {
          await window.dataLayer.push({ event: 'optimize.activate' })
        }
        const intervalId = setInterval(() => {
          intervalCountRef.current += 1;
          if (window.google_optimize !== undefined) {
            const variantReturned = window.google_optimize.get(experimentId);
            if(variantReturned !== undefined){
                setVariant(
                    testingVariant ? String(testingVariant) : variantReturned
                );
                clearInterval(intervalId);
            }
          }else{
            setVariant(undefined);
          }
          if(intervalCountRef.current > 25){
            setVariant(0);
            clearInterval(intervalId);
          }
        }, 200);
      })();
    })
    return variant;
  }

export const identifySegment = (user) => {
    console.log('identify', user)
    if (process.env.NODE_ENV !== "development" && user?.id){
        const data = {
            email: user.email ? user.email : null,
            completedOnboarding: user.completedOnboardingQuiz
                ? user.completedOnboardingQuiz
                : null,
            isActive: user.isActive ? "yes" : "no",
            isTrial: user.isTrial ? "yes" : "no",
            trialStartDate: user.trialStartDate ? user.trialStartDate : null,
            trialEndDate: user.trialEndDate ? user.trialEndDate : null,
            paidSubStartDate: user.paidSubStartDate ? user.paidSubStartDate : null,
            daysActive: user.daysActive ? user.daysActive : null,
            firstName: user.firstName ? user.firstName : null,
            quizAnswers: user.quizAnswers ? user.quizAnswers : null,
            cancellationDate: user.cancellationDate ? user.cancellationDate : null,
            subscriptionStatus: user.subscriptionStatus
                ? user.subscriptionStatus
                : null,
            subscriptionPrice: user.subscriptionPrice
                ? user.subscriptionPrice
                : null,
        }
        window?.analytics?.identify(String(user.id), data)
    }
};
